/* eslint-disable max-len */
import styled from 'styled-components';
import { EmptyStateProps } from './EmptyState.types';

export const StyledEmptyStateWrapper = styled.div<{ 
  background: NonNullable<EmptyStateProps['background']>;
}>`
  width: 600px;
  max-width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.background === 'grey' ? `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    background: var(--allie-color-neutral-10);
    z-index: 1000;
  ` : `
    margin: 0 auto;
  `}
`;

export const StyledEmptyStateContainer = styled.div<{ 
  size: NonNullable<EmptyStateProps['size']>; 
  background: NonNullable<EmptyStateProps['background']>;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.size === 'large' ? 'var(--allie-spacing-6xl) var(--allie-spacing-3xl)' : 'var(--allie-spacing-4xl) var(--allie-spacing-xl)'};
  background: ${props => props.background === 'grey' ? 'var(--allie-color-neutral-10)' : 'var(--allie-color-white)'};
  min-height: ${props => props.size === 'large' ? '400px' : props.size === 'medium' ? '350px' : '300px'};
`;

export const StyledIconWrapper = styled.div<{ 
  size: NonNullable<EmptyStateProps['size']>;
  background: NonNullable<EmptyStateProps['background']>;
}>`
  width: ${props => props.size === 'large' ? 'var(--allie-spacing-6xl)' : 'var(--allie-spacing-5xl)'};
  height: ${props => props.size === 'large' ? 'var(--allie-spacing-6xl)' : 'var(--allie-spacing-5xl)'};
  border-radius: var(--allie-radius-full);
  background-color: ${props => props.background === 'grey' ? 'var(--allie-color-white)' : 'var(--allie-color-neutral-10)'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${props => props.size === 'large' ? 'var(--allie-spacing-3xl)' : props.size === 'medium' ? 'var(--allie-spacing-xl)' : 'var(--allie-spacing-xl)'};
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: default;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: var(--allie-shadow-md);
  }
  
  svg {
    width: ${props => props.size === 'large' ? 'var(--allie-spacing-4xl)' : props.size === 'medium' ? 'var(--allie-spacing-3xl)' : 'var(--allie-spacing-xl)'};
    height: ${props => props.size === 'large' ? 'var(--allie-spacing-4xl)' : props.size === 'medium' ? 'var(--allie-spacing-3xl)' : 'var(--allie-spacing-xl)'};
    color: var(--allie-color-neutral-40);
    transition: transform 0.3s ease;
  }
  
  ion-icon {
    font-size: ${props => props.size === 'large' ? 'var(--allie-spacing-4xl)' : props.size === 'medium' ? 'var(--allie-spacing-3xl)' : 'var(--allie-spacing-xl)'};
    width: ${props => props.size === 'large' ? 'var(--allie-spacing-4xl)' : props.size === 'medium' ? 'var(--allie-spacing-3xl)' : 'var(--allie-spacing-xl)'};
    height: ${props => props.size === 'large' ? 'var(--allie-spacing-4xl)' : props.size === 'medium' ? 'var(--allie-spacing-3xl)' : 'var(--allie-spacing-xl)'};
    color: var(--allie-color-neutral-40);
  }
  
  &:hover svg {
    transform: rotate(5deg);
  }
`;

export const StyledTitle = styled.h3`
  font-weight: 600;
  color: var(--allie-color-neutral-90);
  margin: 0;
  text-align: center;
  max-width: 20rem;
`;

export const StyledDescription = styled.p`
  color: var(--allie-color-neutral-60);
  text-align: center;
  max-width: 20rem;
  margin: 0;
`;

export const StyledButtonWrapper = styled.div<{ size: NonNullable<EmptyStateProps['size']> }>`
  margin-top: ${props => props.size === 'large' ? 'var(--allie-spacing-3xl)' : props.size === 'medium' ? 'var(--allie-spacing-xl)' : 'var(--allie-spacing-xl)'};
  
  ion-button {
    --padding-top: var(--allie-spacing-xl);
    --padding-bottom: var(--allie-spacing-xl);
    --padding-start: var(--allie-spacing-xl);
    --padding-end: var(--allie-spacing-xl);
  }
  
  ion-button::part(native) {
    padding: var(--allie-spacing-xl) !important;
  }
`;
